import { render, staticRenderFns } from "./algoAdd.vue?vue&type=template&id=8c1d3838&scoped=true&"
import script from "./algoAdd.vue?vue&type=script&lang=js&"
export * from "./algoAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c1d3838",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/sdSdm/sdSdmAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c1d3838')) {
      api.createRecord('8c1d3838', component.options)
    } else {
      api.reload('8c1d3838', component.options)
    }
    module.hot.accept("./algoAdd.vue?vue&type=template&id=8c1d3838&scoped=true&", function () {
      api.rerender('8c1d3838', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/setting/algoCreator/algoAdd.vue"
export default component.exports